import { makeReg3 } from './textStyles';
const checkboxStyles = (tokens) => ({
    variants: {
        primary: {
            label: makeReg3(tokens, {
                color: tokens.TextMedium600,
                marginLeft: tokens.Spacing05,
            }),
            icon: {
                color: tokens.TogglesFill,
                _checked: {
                    backgroundColor: tokens.TogglesSelected,
                },
                _disabled: {
                    backgroundColor: 'rgba(0, 26, 26, 0.4)',
                },
            },
            control: {
                outline: 'none',
                width: '24px',
                height: '24px',
                borderColor: tokens.TogglesStroke,
                borderRadius: tokens.BorderRadius01,
                alignSelf: 'start',
                _focusVisible: {
                    outline: `1px solid ${tokens.BorderFocus}`,
                    boxShadow: 'none',
                },
                _checked: {
                    borderColor: tokens.TogglesStroke,
                    backgroundColor: tokens.TogglesSelected,
                    borderRadius: tokens.BorderRadius01,
                    _hover: {
                        borderColor: tokens.TogglesStroke,
                        backgroundColor: tokens.TogglesSelected,
                        borderRadius: tokens.BorderRadius01,
                    },
                    _disabled: {
                        borderColor: 'rgba(94, 88, 86, 0.6)',
                        backgroundColor: 'rgba(94, 88, 86, 0.6)',
                        borderRadius: tokens.BorderRadius01,
                        background: 'auto',
                    },
                },
            },
        },
    },
});
export default checkboxStyles;
